/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Chat Backend API
 * API for chat application
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';

import { HttpResponse, delay, http } from 'msw';

import { createAccountInstance } from '../../api-instance';
import type { BodyType } from '../../api-instance';
export interface CreateUserRequest {
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  account_type: string;
  locate?: string;
}

export interface RegisterRequest {
  email: string;
  /** @minLength 6 */
  password: string;
  locale?: string;
}

export interface AuthResponse {
  /** JWT access token */
  auth_token?: string;
}

export interface User {
  id: string;
  account_id: string;
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  locale: string;
  timezone: string;
  role: string;
  is_active: boolean;
  created_at: string;
  last_activity_at: string;
  need_to_change_password: boolean;
  password_changed_at: string;
}

export interface UpdateMeRequest {
  first_name?: string;
  last_name?: string;
  locale?: string;
  timezone?: string;
  phone?: string;
}

export interface Error {
  code: string;
  details: string;
}

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get the current profile details
 * @summary Get profile details
 */
export const getApiV1Me = (
  options?: SecondParameter<typeof createAccountInstance>
) => {
  return createAccountInstance<User>(
    { url: `/api/v1/me`, method: 'GET' },
    options
  );
};

/**
 * Updates the profile of the currently authenticated user
 * @summary Update profile
 */
export const patchApiV1Me = (
  updateMeRequest: BodyType<UpdateMeRequest>,
  options?: SecondParameter<typeof createAccountInstance>
) => {
  return createAccountInstance<void>(
    {
      url: `/api/v1/me`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateMeRequest,
    },
    options
  );
};

/**
 * Get user data by id
 * @summary Get user data by id
 */
export const getApiV1UserUserId = (
  userId: string,
  options?: SecondParameter<typeof createAccountInstance>
) => {
  return createAccountInstance<User>(
    { url: `/api/v1/user/${userId}`, method: 'GET' },
    options
  );
};

export type GetApiV1MeResult = NonNullable<
  Awaited<ReturnType<typeof getApiV1Me>>
>;
export type PatchApiV1MeResult = NonNullable<
  Awaited<ReturnType<typeof patchApiV1Me>>
>;
export type GetApiV1UserUserIdResult = NonNullable<
  Awaited<ReturnType<typeof getApiV1UserUserId>>
>;

export const getGetApiV1MeResponseMock = (
  overrideResponse: Partial<User> = {}
): User => ({
  id: faker.string.uuid(),
  account_id: faker.string.alpha(20),
  email: faker.string.alpha(20),
  first_name: faker.string.alpha(20),
  last_name: faker.string.alpha(20),
  phone: faker.string.alpha(20),
  locale: faker.string.alpha(20),
  timezone: faker.string.alpha(20),
  role: faker.string.alpha(20),
  is_active: faker.datatype.boolean(),
  created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
  last_activity_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
  need_to_change_password: faker.datatype.boolean(),
  password_changed_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
  ...overrideResponse,
});

export const getGetApiV1UserUserIdResponseMock = (
  overrideResponse: Partial<User> = {}
): User => ({
  id: faker.string.uuid(),
  account_id: faker.string.alpha(20),
  email: faker.string.alpha(20),
  first_name: faker.string.alpha(20),
  last_name: faker.string.alpha(20),
  phone: faker.string.alpha(20),
  locale: faker.string.alpha(20),
  timezone: faker.string.alpha(20),
  role: faker.string.alpha(20),
  is_active: faker.datatype.boolean(),
  created_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
  last_activity_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
  need_to_change_password: faker.datatype.boolean(),
  password_changed_at: `${faker.date.past().toISOString().split('.')[0]}Z`,
  ...overrideResponse,
});

export const getGetApiV1MeMockHandler = (
  overrideResponse?:
    | User
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<User> | User)
) => {
  return http.get('*/api/v1/me', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetApiV1MeResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getPatchApiV1MeMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0]
      ) => Promise<void> | void)
) => {
  return http.patch('*/api/v1/me', async (info) => {
    await delay(1000);
    if (typeof overrideResponse === 'function') {
      await overrideResponse(info);
    }
    return new HttpResponse(null, { status: 204 });
  });
};

export const getGetApiV1UserUserIdMockHandler = (
  overrideResponse?:
    | User
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<User> | User)
) => {
  return http.get('*/api/v1/user/:userId', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetApiV1UserUserIdResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};
export const getChatBackendAPIMock = () => [
  getGetApiV1MeMockHandler(),
  getPatchApiV1MeMockHandler(),
  getGetApiV1UserUserIdMockHandler(),
];
